/**
 * Polyfill function that generates an `inset` property to an element. This is a shorthand for the
 * `top`, `right`, `bottom`, and `left` properties.
 *
 * @param value - The value to apply to all sides.
 */ function inset(value) {
    return {
        top: value,
        right: value,
        bottom: value,
        left: value
    };
}

export { inset };
//# sourceMappingURL=inset.js.map
